export default {
    logo: 'https://firebasestorage.googleapis.com/v0/b/tibiawallstreet.appspot.com/o/front%2Fdragonscaleoutfit.png?alt=media&token=9e70ea2e-0378-4948-aeb0-c238a952fbe7',
    femaleLogo: 'https://firebasestorage.googleapis.com/v0/b/tibiawallstreet.appspot.com/o/front%2FfemaleDragonScale.png?alt=media&token=ce1fe907-2664-4224-ba5b-1c9e95df5fd2',
    background: "https://firebasestorage.googleapis.com/v0/b/tibiawallstreet.appspot.com/o/front%2FThais1920x1200.jpg?alt=media&token=c59754aa-2f47-4baf-84c2-a85c03ec4448",
    effects: {
        fireStatus: "https://firebasestorage.googleapis.com/v0/b/tibiawallstreet.appspot.com/o/front%2FBurning_1x.gif?alt=media&token=7c202d22-36bc-4b94-9043-53a39a9a8706"
    },
    items: {
        ferumbrasHat: 'https://firebasestorage.googleapis.com/v0/b/tibiawallstreet.appspot.com/o/items%2FFerumbras_Hat.gif?alt=media&token=2022bc78-0743-4820-b8ef-003a158335ad'

    }
}